import { render, staticRenderFns } from "./Devengados.vue?vue&type=template&id=8785963e"
import script from "./Devengados.vue?vue&type=script&lang=js"
export * from "./Devengados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports